module.exports = __webpack_public_path__ + "static/3-6c80ef29fee7f750b87559207645616a.jpg";